export default __webpack_public_path__ + "static/media/nb.1e17da50.png";